import { Building2, Plus } from "lucide-react";
import { AccountBadges } from "@/components/AccountBadges";

const Option = ({ active, onClick, testid, children }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left text-sm transition-colors ${active ? "border-[#F7931A] bg-[#F7931A]/10" : "border-[#212638] bg-[#0F111A] hover:bg-[#1C2030]"}`}>
    {children}
  </button>
);

export const SavedAccountPicker = ({ accounts, value, onChange }) => (
  <div className="space-y-2" data-testid="withdraw-saved-accounts">
    <p className="text-xs font-semibold uppercase tracking-[0.15em] text-[#64748B]">Pay out to</p>
    {accounts.map((a) => (
      <Option key={a.account_id} active={value === a.account_id} onClick={() => onChange(a.account_id)} testid={`withdraw-saved-account-${a.account_id}`}>
        <Building2 size={16} className="text-[#F7931A]" />
        <span className="flex-1"><span className="block font-semibold">{a.bank_name} <span className="font-mono text-[#94A3B8]">••••{a.last4}</span></span><span className="text-xs text-[#94A3B8]">{a.account_holder}</span></span>
        <AccountBadges a={a} />
      </Option>
    ))}
    <Option active={value === "new"} onClick={() => onChange("new")} testid="withdraw-new-account-option">
      <Plus size={16} className="text-[#94A3B8]" /> <span className="font-semibold">Use a new bank account</span>
    </Option>
  </div>
);
